<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="getData"
      @openEditForm="openEditForm"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @openEditForm="openEditForm"
      />
    </page-main>

    <FabricEditForm
      :pdProcessDictCode="pdProcessDictCode"
      :visible.sync="fabricEditFormOptions.visible"
      :pdProcessDictFabricCode="fabricEditFormOptions.code"
      :disabled="fabricEditFormOptions.disabled"
      :is-copy="fabricEditFormOptions.isCopy"
      @reload="getData"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import FabricEditForm from '../fabric-edit-form'
export default {
  components: { PageHeader, PageMain, FabricEditForm },
  props: {
    disabled: { type: Boolean, default: false },
    pdProcessDictCode: { type: String, default: '' },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      fabricEditFormOptions: {
        visible: false,
        code: '',
        disabled: false,
        isCopy: false,
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .processDictionaryFabricListApi({
          pdProcessDictCode: this.pdProcessDictCode,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
    },
    openEditForm({ type, params = {} }) {
      const { pdProcessDictFabricCode: code } = params
      this.fabricEditFormOptions = {
        visible: true,
        code,
        disabled: type === 'detail',
        isCopy: type === 'copy',
      }
    },
  },
}
</script>
